import { Watermark } from '@src/modules/players/shared/interfaces/player-configs.interface';

export function makeWatermarkDataURL(text: string, options: Watermark) {
  const {
    fontSize = 16,
    fontFamily = 'sans-serif',
    color = 'rgba(179, 179, 179, 0.5)',
    angleDeg = -45,
  } = options;

  const padding = 20;
  // 1) 임시 캔버스로 텍스트 메트릭 구하기
  const measureCanvas = document.createElement('canvas');
  const mctx = measureCanvas.getContext('2d')!;
  mctx.font = `${fontSize}px ${fontFamily}`;
  // measure width
  const metrics = mctx.measureText(text);
  const textWidth = metrics.width;
  // 실제 그려지는 텍스트 높이(Ascent + Descent)
  const textHeight =
    (metrics.actualBoundingBoxAscent || fontSize) +
    (metrics.actualBoundingBoxDescent || 0);

  // 2) 회전된 바운딩 박스 크기 계산
  const rad = (angleDeg * Math.PI) / 180;
  const absCos = Math.abs(Math.cos(rad));
  const absSin = Math.abs(Math.sin(rad));
  const boxWidth = textWidth * absCos + textHeight * absSin;
  const boxHeight = textWidth * absSin + textHeight * absCos;

  // 3) 최종 캔버스 크기
  const canvasSizeW = Math.ceil(boxWidth + padding * 2);
  const canvasSizeH = Math.ceil(boxHeight + padding * 2);

  const canvas = document.createElement('canvas');
  canvas.width = canvasSizeW;
  canvas.height = canvasSizeH;
  const ctx = canvas.getContext('2d');

  // 스타일 세팅
  ctx.fillStyle = color;
  ctx.font = `${fontSize}px ${fontFamily}`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  // 캔버스 중심으로 이동 후 회전
  ctx.translate(canvasSizeW / 2, canvasSizeH / 2);

  ctx.rotate(rad);

  // 중앙(0,0)에 텍스트 그리기
  ctx.fillText(text, 0, 0);

  return canvas.toDataURL('image/png');
}
